import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { ErrorBoundaryComponent } from "#/components/error-boundary";
import { RouteDrawer } from "#/components/route-drawer";

export const Route = createFileRoute(
  "/$locale/{-$schoolyear}/_authenticated/$school/lessons/te-behandelen/drawer",
)({
  component: ActivitiesDrawer,
  errorComponent: ActivitiesDrawerError,
});

function ActivitiesDrawer() {
  const navigate = useNavigate();

  return (
    <RouteDrawer
      onClose={() => {
        // Close by returning to the activities list, preserving the current filter search params.
        void navigate({
          from: Route.fullPath,
          to: "/$locale/{-$schoolyear}/$school/lessons/te-behandelen",
          params: (prev) => prev,
          search: (prev) => prev,
          replace: true,
          resetScroll: false,
          viewTransition: true,
        });
      }}
    >
      <Outlet />
    </RouteDrawer>
  );
}

function ActivitiesDrawerError({ error }: { error: unknown }) {
  const params = Route.useParams();
  return <ErrorBoundaryComponent error={error} params={params} />;
}
